module.exports = __webpack_public_path__ + "img/bg-bar2.ecf5665c.jpg";